<template lang="pug">
.real-estate-carousel(v-if="realEstateImagesSorted.length", :class="zoomed ? 'real-estate-carousel--zoomed' : ''")
	.real-estate-carousel__carousel
		button.real-estate-carousel__close(v-if="zoomed", @click="toogleZoom()")
			span.sr-only Nagyítás
		.image-index
			svg(width="12", height="12", viewBox="0 0 12 12", fill="none", xmlns="http://www.w3.org/2000/svg")
				path(
					d="M6.00039 7.60039C6.88405 7.60039 7.60039 6.88405 7.60039 6.00039C7.60039 5.11673 6.88405 4.40039 6.00039 4.40039C5.11673 4.40039 4.40039 5.11673 4.40039 6.00039C4.40039 6.88405 5.11673 7.60039 6.00039 7.60039Z",
					fill="#FFFFFF"
				)
				path(
					d="M4.5 1L3.585 2H2C1.4475 2 1 2.4475 1 3V9C1 9.5525 1.4475 10 2 10H10C10.5525 10 11 9.5525 11 9V3C11 2.4475 10.5525 2 10 2H8.415L7.5 1H4.5ZM6 8.5C4.62 8.5 3.5 7.38 3.5 6C3.5 4.62 4.62 3.5 6 3.5C7.38 3.5 8.5 4.62 8.5 6C8.5 7.38 7.38 8.5 6 8.5Z",
					fill="#FFFFFF"
				)
			| {{ imageIndex + 1 }} / {{ realEstateImagesSorted.length }}
		VueSlickCarousel(ref="carousel", v-bind="carouselSettings", @beforeChange="setImageIndex")
			.image-wrapper(v-for="(image, index) in realEstateImagesSorted")
				a.real-estate-carousel__webwalk(v-if="index == imageIndex && image.websetaUrl", target="_blank", :href="image.websetaUrl" title="Egy különleges, prémium kategóriás virtuális séta, melynek segítségével megtekintheti az egész ingatlan minden részletét.")
					svg(width="24", height="24", viewBox="0 0 24 24", fill="none", xmlns="http://www.w3.org/2000/svg")
						path(
							d="M5 10C3.15 10.818 2 11.971 2 13.247C2 15.732 6.365 17.747 11.75 17.747H12.5",
							stroke="#52AE30",
							stroke-linecap="round",
							stroke-linejoin="round"
						)
						path(
							d="M18.509 10.0078C20.353 10.8258 21.5 11.9768 21.5 13.2508C21.5 14.9868 19.37 16.4938 16.25 17.2438",
							stroke="#52AE30",
							stroke-linecap="round",
							stroke-linejoin="round"
						)
						path(d="M11 19.25L12.5 17.75L11 16.25", stroke="#52AE30", stroke-linecap="round", stroke-linejoin="round")
						path(
							d="M8.50732 8.40527H9.00391C9.32324 8.40527 9.56934 8.30713 9.74219 8.11084C9.91504 7.91455 10.0015 7.64648 10.0015 7.30664C10.0015 6.55664 9.71143 6.18164 9.13135 6.18164C8.85303 6.18164 8.63477 6.28271 8.47656 6.48486C8.31836 6.68701 8.23926 6.95215 8.23926 7.28027H7.46582C7.46582 6.76758 7.62109 6.3457 7.93164 6.01465C8.24512 5.68066 8.64502 5.51367 9.13135 5.51367C9.63525 5.51367 10.0352 5.67188 10.3311 5.98828C10.627 6.30176 10.7749 6.74707 10.7749 7.32422C10.7749 7.62012 10.6973 7.89697 10.542 8.15479C10.3896 8.40967 10.1904 8.59717 9.94434 8.71729C10.5479 8.93994 10.8496 9.43945 10.8496 10.2158C10.8496 10.7871 10.6899 11.2427 10.3706 11.5825C10.0542 11.9194 9.63965 12.0879 9.12695 12.0879C8.62012 12.0879 8.20996 11.9282 7.89648 11.6089C7.58594 11.2866 7.43066 10.8545 7.43066 10.3125H8.2085C8.2085 10.6523 8.29053 10.9233 8.45459 11.1255C8.61865 11.3247 8.84277 11.4243 9.12695 11.4243C9.41699 11.4243 9.64697 11.3262 9.81689 11.1299C9.98975 10.9336 10.0762 10.6348 10.0762 10.2334C10.0762 9.45703 9.7085 9.06885 8.97314 9.06885H8.50732V8.40527ZM12.1372 12V5.60156H13.6621C14.4092 5.60156 14.9893 5.83594 15.4023 6.30469C15.8154 6.77051 16.022 7.42676 16.022 8.27344V9.3457C16.022 10.1924 15.8125 10.8472 15.3936 11.3101C14.9746 11.77 14.3667 12 13.5698 12H12.1372ZM12.9414 6.2959V11.3101H13.5874C14.1528 11.3101 14.5659 11.1489 14.8267 10.8267C15.0874 10.5015 15.2207 10.021 15.2266 9.38525V8.25146C15.2266 7.57764 15.0962 7.08398 14.8354 6.77051C14.5776 6.4541 14.1865 6.2959 13.6621 6.2959H12.9414Z",
							fill="#52AE30"
						)
					| {{ $t('AADAT.webWalk') }}
				img(:src="image.url", :alt="getAlt(index)", @click="toogleZoom()")
				button.layout-btn(v-if="hasLayout", @click="goToLayout")  Alaprajz
			template(slot="prevArrow")
				span.custom-arrow {{ $t('AADAT.prevPic') }}
			template(slot="nextArrow")
				span.custom-arrow {{ $t('AADAT.nextPic') }}
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import isMobile from '../../common/js/is-mobile/is-mobile';
const isIE = () => {
	return /Trident\/|MSIE/.test(window.navigator.userAgent);
};
const SLICK_DESKTOP_SETTINGS = {
	slidesToShow: 1,
	slidesToScroll: 1,
	infinite: true,
	centerMode: true,
	variableWidth: true
};
const SLICK_MOBILE_SETTINGS = {
	lazyLoad: 'ondemand',
	slidesToShow: 1,
	slidesToScroll: 1
};
export default {
	mixins: [isMobile],
	data: () => ({
		imageIndex: 0,
		zoomed: false
	}),
	components: {
		VueSlickCarousel
	},
	computed: {
		...mapState('real-estate-data', ['h2']),
		...mapGetters('real-estate-data', ['realEstateImagesSorted']),
		carouselSettings() {
			const isMobileOrIe = this.isMobile || isIE() || this.realEstateImagesSorted.length == 1;
			return isMobileOrIe ? SLICK_MOBILE_SETTINGS : SLICK_DESKTOP_SETTINGS;
		},
		explorerView() {
			return isIE();
		},
		hasLayout() {
			return this.realEstateImagesSorted.some((image) => image.isLayout);
		},
		layoutIndex() {
			return this.realEstateImagesSorted.findIndex((image) => image.isLayout);
		}
	},
	methods: {
		getAlt(index) {
			const propertyImage = this.$t('AADAT.propertyImage');
			return `${this.h2} - ${propertyImage} (${index + 1})`;
		},
		setImageIndex(oldIndex, index) {
			this.imageIndex = index;
			this.sendGTM();
		},
		toogleZoom() {
			this.zoomed = !this.zoomed;

			if (this.zoomed) {
				document.body.classList.add('modal-open');
			} else {
				document.body.classList.remove('modal-open');
			}
		},
		sendGTM() {
			const params = new URLSearchParams(window.location.search);
			const propertyID = params.get('m');
			this.$gtm.trackEvent({
				event: 'pageInit',
				pageType: 'Ingatlan végoldal',
				propertyID
			});
		},
		goToLayout() {
			this.$refs.carousel.goTo(this.layoutIndex);
		}
	}
};
</script>
<style lang="css" scoped>
@import '../../common/variables.pcss';

.layout-btn {
	background-color: var(--light-grey);
	border-radius: 5px;
	border: none;
	color: var(--text-primary);
	display: none;
	font-weight: 600;
	padding: 8px 16px;
	position: absolute;
	right: -20px;
	top: 90%;
	transform: translate(-50%, -50%);
}

.slick-active .layout-btn {
	display: block;
}

.layout-btn:hover {
	color: var(--black);
}

.image-index {
	align-items: center;
	background-color: rgba(255, 255, 255, 0);
	color: var(--white);
	display: none;
	font-size: 12px;
	height: 28px;
	justify-content: space-between;
	left: 20px;
	min-width: 49px;
	padding: 9px;
	position: absolute;
	top: 13px;
	z-index: 1;

	@media (--desktop) {
		display: flex;
	}

	& > svg {
		margin-right: 5px;
		min-height: 10px;
		min-width: 10px;
	}
}

.real-estate-carousel__carousel {
	height: 213px;
	overflow: hidden;
	position: relative;

	@media (--desktop) {
		height: 440px;
		box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
	}
}

.real-estate-carousel >>> .slick-slide {
	cursor: zoom-in;
}

.real-estate-carousel .custom-arrow.slick-arrow {
	background-color: rgba(255, 255, 255, 0.5);
	border-radius: 50%;
	height: 32px;
	width: 32px;
	z-index: 1;

	@media (--desktop) {
		border-radius: 50%;
		height: 80px;
		margin: 0 10px;
		top: 220px;
		width: 80px;
	}
}

.real-estate-carousel--zoomed .custom-arrow.slick-arrow {
	margin: 0 40px;
}

.real-estate-carousel .custom-arrow.slick-arrow::before {
	background: url('/static/assets/img/carousel-arrow.svg') center center / 20px 48px no-repeat;
	content: '';
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;

	@media (--under-desktop) {
		align-items: center;
		background: url('/static/assets/img/green-arrow.svg') center center / 10px 16px no-repeat;
		display: flex;
		justify-content: center;
		opacity: 1;
		position: absolute;
		transform: none;
	}
}

.real-estate-carousel .custom-arrow.slick-arrow.slick-prev {
	left: 7px;

	@media (--desktop) {
		left: 0;
	}
}

.real-estate-carousel .custom-arrow.slick-arrow.slick-next {
	right: 7px;

	@media (--desktop) {
		right: 0;
	}
}

.real-estate-carousel .custom-arrow.slick-arrow.slick-prev::before {

	@media (--desktop) {
		left: -3px;
	}
}

.real-estate-carousel .custom-arrow.slick-arrow.slick-next::before {
	@media (--desktop) {
		left: 3px;
	}
}

.real-estate-carousel .custom-arrow.slick-arrow.slick-next::before {
	transform: rotateY(180deg);
}

.real-estate-carousel .image-wrapper {
	height: 213px;
	position: relative;

	@media (--desktop) {
		height: 440px;
		width: 626px !important;
	}
}

.real-estate-carousel .image-wrapper.one-image {
	width: 100% !important;
}

.real-estate-carousel .image-wrapper img {
	left: 50%;
	min-height: 100%;
	min-width: 100%;
	position: absolute;
	top: 50%;
	transform: translate(-50%, -50%);
}

.real-estate-carousel__webwalk {
	align-items: center;
	background-color: rgba(255, 255, 255, 0.9);
	border-radius: 4px;
	border: 0;
	color: var(--green);
	display: flex;
	font-size: 16px;
	line-height: 28px;
	padding: 0 8px;
	position: absolute;
	right: 22px;
	top: 13px;
	z-index: 1;

	& svg {
		margin-right: 8px;
	}

	&:focus {
		outline: none;
	}
}

.image-wrapper.one-image .real-estate-carousel__webwalk {
	@media (--desktop) {
		right: 162px;
	}
}
</style>
<style lang="css" scoped>
@import '../../common/variables.pcss';

.real-estate-carousel--zoomed {
	background: #767676;
	height: 100%;
	left: 0;
	margin: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 100;
}

.real-estate-carousel--zoomed .real-estate-carousel__carousel {
	top: 50%;
	transform: translateY(-50%);
	height: 100%;
}

.real-estate-carousel--zoomed .image-wrapper {
	height: 100vh;

	@media (--desktop) {
		width: 900px !important;
	}
}

.real-estate-carousel--zoomed >>> .slick-slide img {
	cursor: zoom-out;
	min-height: 0;

	@media (--desktop) {
		transition: 0.5s;
		opacity: 0;
	}
}

.real-estate-carousel--zoomed >>> .slick-current img {
	@media (--desktop) {
		opacity: 1;
	}
}

.real-estate-carousel--zoomed .custom-arrow.slick-arrow {
	@media (--desktop) {
		top: 50%;
	}
}

.real-estate-carousel--zoomed .real-estate-carousel__close {
	background-color: rgba(74, 74, 74, .8);
	border-radius: 50%;
	border: 0;
	color: var(--white);
	height: 50px;
	position: absolute;
	right: 30px;
	top: 40px;
	width: 50px;
	z-index: 100;
}

.real-estate-carousel--zoomed .real-estate-carousel__close:before {
	background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 1.61143L14.3886 0L8 6.38857L1.61143 0L0 1.61143L6.38857 8L0 14.3886L1.61143 16L8 9.61143L14.3886 16L16 14.3886L9.61143 8L16 1.61143Z' fill='white'/%3E%3C/svg%3E");
	content: "";
	display: block;
	height: 16px;
	margin: 0 auto;
	width: 16px;
}

.real-estate-carousel--zoomed .image-index {
	border-radius: 0 0 5px 0;
	cursor: default;
	height: 36px;
	top: 0;
	width: 70px;
}

.real-estate-carousel--zoomed .real-estate-carousel__webwalk {
	border-radius: 0 0 4px 4px;
	line-height: 36px;
	right: 155px;
	top: 0;

	@media (--under-desktop) {
		right: 50px;
	}
}
</style>